import { render, staticRenderFns } from "./sharia_jadwalsholat.vue?vue&type=template&id=31bb0e2a"
import script from "./sharia_jadwalsholat.vue?vue&type=script&lang=js"
export * from "./sharia_jadwalsholat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports